import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { HierarchyReadDto } from "./HierarchyReadDto";

export type ICopyReportReturn = IAxiosReturn<HierarchyReadDto>;

/**
 * Request body sent to the backend when copying a report, matching the
 * backend's `CopyReportDto` record.
 */
export interface CopyReportDto {
  hierarchyId: string;
  parentTag: string;
  newReportName: string;
  description: string;
  reportType: string;
}

/**
 * Parameters used by the frontend to request that a report is copied.
 *
 * The report identifier is supplied in the endpoint path, while the remaining
 * values are sent in the request body as a {@link CopyReportDto}.
 */
export interface CopyReportParams extends CopyReportDto {
  reportId: string;
}

/**
 * Copy a report into a hierarchy as a new report name.
 *
 * @param backEndUrl - Base backend URL
 * @param params - Parameters for the copy operation
 * @param controller - AbortController for cancelling the request.
 * @returns Newly created hierarchy information when successful
 */
export const copyReport = async (
  backEndUrl: string,
  params: CopyReportParams,
  controller: AbortController,
): Promise<ICopyReportReturn> => {
  const url = `${backEndUrl}Reports/CopyReport/${params.reportId}`;
  const { reportId: _reportId, ...body } = params;
  try {
    const response = await axios.post(url, body, { signal: controller.signal });
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("Copy report failed", error);
  }
};
